import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Utils from "../utils/Utils";

// filepath: /Volumes/DEV/ykop/ykop-client-frontend/src/redux/subscriptionSlice.js

const { serverURL } = Utils;

const initialState = {
    subscription: null,
    loader: true,
    status: "idle",
};

export const fetchActiveSubscription = createAsyncThunk(
    "subscription/fetchActive",
    async (userId) => {
        const response = await fetch(
            `${serverURL}/subscriptions/active-subscription/${userId}`,
            {
                method: "GET",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
            }
        );
        if (!response.ok) throw new Error(await response.text());
        const data = await response.json();
        return data;
    }
);

export const subscriptionSlice = createSlice({
    name: "subscription",
    initialState,
    reducers: {
        setSubscription: (state, action) => {
            state.subscription = action.payload.subscription;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchActiveSubscription.pending, (state) => {
                state.status = "loading";
                state.loader = true;
            })
            .addCase(fetchActiveSubscription.fulfilled, (state, action) => {
                state.subscription = action.payload.data;
                state.status = "success";
                state.loader = false;
            })
            .addCase(fetchActiveSubscription.rejected, (state) => {
                state.status = "failed";
                state.loader = false;
            });
    },
});

export default subscriptionSlice.reducer;
export const { setSubscription } = subscriptionSlice.actions;